import { render, staticRenderFns } from "./conversation-related.vue?vue&type=template&id=2bb7c4c7&scoped=true&"
import script from "./conversation-related.vue?vue&type=script&lang=js&"
export * from "./conversation-related.vue?vue&type=script&lang=js&"
import style0 from "./conversation-related.vue?vue&type=style&index=0&id=2bb7c4c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7c4c7",
  null
  
)

export default component.exports